import React from 'react';
import { useNavigate } from 'react-router-dom';
import CommonDataTable from './commonTable';
import PostedJobDetails from '../OffCanvas/others/PostedJobDetails';
import { __jobStatusDisplay } from '../../constants';
import styled from '@emotion/styled';
import { formatWithTZ } from '../../utils';

const JobPosted = () => {
  const navigate = useNavigate();
  const [canvasState, setCanvasState] = React.useState({
    open: false,
    userId: "",
    applicationId: ""
  });

  const handleClick = (id) => {
    navigate(`appliers?id=${id}`);
  };

  const columns = [
    {
      id: "status",
      label: "Status",
      width: "1.6fr",
      isDefault: true,
      render: (item, statusClassMap) => (
        <li className="pointer" style={{ overflow: "hidden", display: "flex" }}>
          <span className={`list_card_status ${statusClassMap[item.jobStatus] || ""}`}>
            {__jobStatusDisplay[item.jobStatus] || "Unknown"}
          </span>
        </li>
      )
    },
    {
      id: "jobNo",
      label: "Job No",
      width: "1fr",
      isDefault: true,
      render: (item) => <li>{item.displayedJobId || "NA"}</li>
    },
    {
      id: "description",
      label: "Job description",
      width: "2.5fr",
      isDefault: false,
      render: (item) => <li>{item.jobDescription || "NA"}</li>
    },
    {
      id: "postedBy",
      label: "Posted by",
      width: "2fr",
      isDefault: true,
      render: (item) => (
        <li 
          className="pointer" 
          onClick={(e) => { e.stopPropagation(); navigate("/users/seekers-listing?id=" + item.jobPostedBy._id); }}
        >
          {item.jobPostedBy.firstName} {item.jobPostedBy.lastName}
        </li>
      )
    },
    {
      id: "postedFor",
      label: "Posted for",
      width: "1fr",
      isDefault: true,
      render: (item) => <li>{item.jobPostedFor}</li>
    },
    {
      id: "durationType",
      label: "Duration Type",
      width: "1.2fr",
      isDefault: true,
      render: (item) => (
        <li style={{ overflow: "hidden", display: "flex" }}>
          <span className={`list_card_status ${
            item.durationType === "Immediate" ? "duration_immediate" :
            item.durationType === "Long Term" ? "duration_long_term" :
            "duration_future"
          }`}>
            {item.durationType || "Future"}
          </span>
        </li>
      )
    },
    {
      id: "applications",
      label: "Applications",
      width: "1.5fr",
      isDefault: true,
      style: { textAlign: "center" },
      render: (item) => (
        <li 
          onClick={(e) => { e.stopPropagation(); handleClick(item._id); }} 
          className="pointer text-center"
        >
          {item.appliedJobs}
        </li>
      )
    },
    {
      id: "postedOn",
      label: "Posted on",
      width: "1.2fr",
      isDefault: false,
      render: (item) => <li>{formatWithTZ(item.createdAt, "Do MMM, YYYY")}</li>
    },
    {
      id: "bookedFinalizedOn",
      label: "Booked / Finalized on",
      width: "1.2fr",
      isDefault: false,
      render: (item) => (
        <li>
          {item?.applicationInfo?.bookedOn
            ? formatWithTZ(item.applicationInfo.bookedOn, "Do MMM, YYYY")
            : "-"}{" "}
          /{" "}
          {item.completedOn
            ? formatWithTZ(item.completedOn, "Do MMM, YYYY")
            : "-"}
        </li>
      )
    },
    {
      id: "stripeDisabled",
      label: "Stripe Disabled",
      width: "1.2fr",
      isDefault: false,
      render: (item) => (
        <li style={{ overflow: "hidden", display: "flex" }}>
          <span className={`list_card_status ${item.stripeDisabled ? "status_inactive" : "status_active"}`}>
            {item.stripeDisabled ? "Disabled" : "Enabled"}
          </span>
        </li>
      )
    }
  ];

  const handleRowClick = (item, setCanvasState) => {
    setCanvasState({
      open: true,
      jobId: item._id,
      applicationId: item._id
    });
  };

  return (
    <JobPostedWrapper>
      <CommonDataTable
        type="Job"
        profileNavTitle="Jobs"
        columns={columns}
        viewColumnWidth="0.5fr"
        onRowClick={handleRowClick}
        canvasComponent={PostedJobDetails}
        canvasState={canvasState}
        setCanvasState={setCanvasState}
        additionalParams={{}}
      />
    </JobPostedWrapper>
  );
};

// Additional styling specific to JobPosted
const JobPostedWrapper = styled.div`
  .list-header:hover {
    background: unset;
  }
`;

export default JobPosted;